// src/LanguageContext.js
import React, { createContext, useState } from 'react';
import { enTranslations } from './en';
import { deTranslations } from './de';

export const LanguageContext = createContext({
  language: 'en',
  setLanguage: () => {},
  translations: {}
});

const translations = {
  en: enTranslations,
  de: deTranslations
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translations }}>
      {children}
    </LanguageContext.Provider>
  );
}
